<template>
  <div
    class="f-center"
    style="gap: 0.25rem"
    @click.stop
  >
    <router-link
      v-for="item in [
        {
          title: $t('links.analyzer_settings'),
          sub: $t('links.analyzer_settings_sub'),
          pathName: 'UserGameSettings',
          icon: 'mdi-cogs',
        },
      ]"
      :key="item.pathName"
      :to="{ name: item.pathName }"
      class="flex-1 f-center"
    >
      <NavCard
        :item="item"
        :hasIcon="false"
        :hasTitleIcon="true"
        :hasSub="false"
        class="flex-1 navcard_centered navcard_reversed_l navcard_small text-nowrap router-link-active-ignore"
        :hasTag="!!item.tag_live"
        style="
          --padding: 0.5rem 0.5rem;
          --clr-back: transparent;
          --icon-inset: 0.075rem auto auto -0.175rem;
        "
      />
    </router-link>
    <a
      v-if="!$i18n.g1"
      :key="linkBlog.pathName"
      :href="linkBlog.href"
      target="_blank"
      class="flex-1 f-center"
    >
      <NavCard
        :item="linkBlog"
        :hasIcon="false"
        :hasTitleIcon="true"
        :hasSub="false"
        :hasTag="false"
        class="flex-1 navcard_centered navcard_reversed_l navcard_small text-nowrap"
        style="
          --padding: 0.5rem 0.5rem;
          --clr-back: transparent;
          --icon-inset: 0.075rem auto auto -0.175rem;
        "
      />
    </a>
  </div>
</template>

<script>
import links_mix from '@/mixins/links_mix'

export default {
  name: 'UploadBoxesLinks',
  mixins: [links_mix],
  props: {},
  data() {
    return {}
  },

  computed: {
    linkBlog() {
      return {
        icon: 'mdi-book-information-variant',
        title: this.$t('links.guide_upload'),
        href: this.links_url_links.uploads_explained.url,
      }
    },
  },
}
</script>
